


































































































































































































































































































































































































































































































































































































































































































































































































































import { default as Component } from 'vue-class-component';
import { AxiosResponse } from 'axios';

import ContractWidget from '@/components/widgets/ContractWidget.vue';
import DatePicker from '@/components/vuejs-datepicker/src/components/Datepicker.vue';
import MessagesBlock from '@/components/snippets/messages/MessagesBlock.vue';

import IocContainer from '@/container/IocContainer';
import SERVICES from '@/container/Services';

import Format from '@/interfaces/Format';
import Api from '@/interfaces/Api';
import Tracking from '@/interfaces/Tracking';

interface CityData {
  text: string;
  zip: string;
  zipText: string;
  name: string;
}

const ApiProvider = IocContainer.get<Api>(SERVICES.API);
const formatProvider = IocContainer.get<Format>(SERVICES.FORMAT);
const trackingProvider = IocContainer.get<Tracking>(SERVICES.TRACKING);

@Component({
  props: {
    minimumAgeRequired: Number,
    isMobile: Boolean
  },
  components: {
    'date-picker': DatePicker,
    'messages-block': MessagesBlock
  },
  filters: {
    zip: formatProvider.zip()
  }
})
export default class HsgContractWidget extends ContractWidget {
  public formSalutations = {
    mr: 1,
    mrs: 2,
    without: 9
  };

  protected cityObject = {};

  protected searchLengthReached = false;
  protected searchQuery = '';

  protected focusPhone = false;

  get isDisabledBillingStreet(): boolean {
    return (
      (this.data.billingCity === '' || this.data.billingCity === null) &&
      (this.data.billingZip === '' || this.data.billingZip === null)
    );
  }

  get locationZip(): string | null {
    return this.sessionState.zip ? this.sessionState.zip : '';
  }

  get locationCity(): string | null {
    return this.sessionState.city ? this.sessionState.city : '';
  }

  get isStreetRequired(): boolean {
    return this.streetData.street !== null && this.streetData.street !== '';
  }

  get isErrorSalutation(): boolean {
    return typeof this.errorHsgSalutation !== 'undefined' && this.errorHsgSalutation !== null;
  }
  get errorHsgSalutation(): { key: string; message: string } | null {
    return this.getHsgError('salutation');
  }

  get isErrorFirstName(): boolean {
    return typeof this.errorHsgFirstName !== 'undefined' && this.errorHsgFirstName !== null;
  }
  get errorHsgFirstName(): { key: string; message: string } | null {
    return this.getHsgError('firstName');
  }

  get isErrorSurname(): boolean {
    return typeof this.errorHsgSurname !== 'undefined' && this.errorHsgSurname !== null;
  }
  get errorHsgSurname(): { key: string; message: string } | null {
    return this.getHsgError('surname');
  }

  get isErrorStreet(): boolean {
    return typeof this.errorHsgStreet !== 'undefined' && this.errorHsgStreet !== null;
  }
  get errorHsgStreet(): { key: string; message: string } | null {
    return this.getHsgError('street');
  }

  get isErrorHouseNumber(): boolean {
    return typeof this.errorHsgHouseNumber !== 'undefined' && this.errorHsgHouseNumber !== null;
  }
  get errorHsgHouseNumber(): { key: string; message: string } | null {
    return this.getHsgError('houseNumber');
  }

  get isErrorDateOfBirth(): boolean {
    return typeof this.errorHsgDateOfBirth !== 'undefined' && this.errorHsgDateOfBirth !== null;
  }
  get errorHsgDateOfBirth(): { key: string; message: string } | null {
    return this.getHsgError('dateOfBirth');
  }

  get isErrorHsgMinimumAgeRequired(): boolean {
    return typeof this.errorHsgMinimumAgeRequired !== 'undefined' && this.errorHsgMinimumAgeRequired !== null;
  }
  get errorHsgMinimumAgeRequired(): [{ key: string; message: string }] | null {
    const message = this.$t('contract.widget.min.age.required', {
      years: this.$props.minimumAgeRequired
    }).toString();
    return this.disabledDatesOfBirth.from.getTime() < new Date(this.data.dateOfBirth || 0).getTime()
      ? [{ key: '', message }]
      : null;
  }

  get isErrorEmailPrivate(): boolean {
    return typeof this.errorHsgEmailPrivate !== 'undefined' && this.errorHsgEmailPrivate !== null;
  }
  get errorHsgEmailPrivate(): { key: string; message: string } | null {
    return this.getHsgError('emailPrivate');
  }

  get isErrorPhoneHome(): boolean {
    return typeof this.errorHsgPhoneHome !== 'undefined' && this.errorHsgPhoneHome !== null;
  }
  get errorHsgPhoneHome(): { key: string; message: string } | null {
    return this.getHsgError('phoneHome');
  }

  get isErrorPhoneMobile(): boolean {
    return typeof this.errorHsgPhoneMobile !== 'undefined' && this.errorHsgPhoneMobile !== null;
  }
  get errorHsgPhoneMobile(): { key: string; message: string } | null {
    return this.getHsgError('phoneMobile');
  }

  get isErrorBillingSalutation(): boolean {
    return typeof this.errorHsgBillingSalutation !== 'undefined' && this.errorHsgBillingSalutation !== null;
  }
  get errorHsgBillingSalutation(): { key: string; message: string } | null {
    return this.getHsgError('billingSalutation');
  }

  get isErrorBillingFirstName(): boolean {
    return typeof this.errorHsgBillingFirstName !== 'undefined' && this.errorHsgBillingFirstName !== null;
  }
  get errorHsgBillingFirstName(): { key: string; message: string } | null {
    return this.getHsgError('billingFirstName');
  }

  get isErrorBillingSurname(): boolean {
    return typeof this.errorHsgBillingSurname !== 'undefined' && this.errorHsgBillingSurname !== null;
  }
  get errorHsgBillingSurname(): { key: string; message: string } | null {
    return this.getHsgError('billingSurname');
  }

  get isErrorBillingStreet(): boolean {
    return typeof this.errorHsgBillingStreet !== 'undefined' && this.errorHsgBillingStreet !== null;
  }
  get errorHsgBillingStreet(): { key: string; message: string } | null {
    return this.getHsgError('billingStreet');
  }

  get isErrorBillingHouseNumber(): boolean {
    return typeof this.errorHsgBillingHouseNumber !== 'undefined' && this.errorHsgBillingHouseNumber !== null;
  }
  get errorHsgBillingHouseNumber(): { key: string; message: string } | null {
    return this.getHsgError('billingHouseNumber');
  }

  get isErrorBillingZip(): boolean {
    return typeof this.errorHsgBillingZip !== 'undefined' && this.errorHsgBillingZip !== null;
  }
  get errorHsgBillingZip(): { key: string; message: string } | null {
    return this.getHsgError('billingZip');
  }

  get isErrorBillingCity(): boolean {
    return typeof this.errorHsgBillingCity !== 'undefined' && this.errorHsgBillingCity !== null;
  }
  get errorHsgBillingCity(): { key: string; message: string } | null {
    return this.getHsgError('billingCity');
  }

  get isErrorBillingPhone(): boolean {
    return typeof this.errorHsgBillingPhone !== 'undefined' && this.errorHsgBillingPhone !== null;
  }
  get errorHsgBillingPhone(): { key: string; message: string } | null {
    return this.getHsgError('billingPhone');
  }

  get isErrorBillingEmail(): boolean {
    return typeof this.errorHsgBillingEmail !== 'undefined' && this.errorHsgBillingEmail !== null;
  }
  get errorHsgBillingEmail(): { key: string; message: string } | null {
    return this.getHsgError('billingEmail');
  }

  get citiesDisplay(): CityData[] | [] {
    if (this.searchLengthReached) {
      const search = parseInt(this.searchQuery, 10) + '';
      const filteredCities = this.cities.filter((city) => {
        if (this.isNumeric(this.searchQuery)) {
          return new RegExp('^' + search).test(city.zip);
        } else {
          return new RegExp('^' + this.searchQuery, 'i').test(city.name);
        }
      });
      return this.citiesNormalizing(filteredCities, 'zip');
    } else {
      return [];
    }
  }

  public citiesInput(value: { zip: string; name: string }): void {
    if (value) {
      this.cityObject = value;
      this.data.billingZip = value.zip;
      this.data.billingCity = value.name;
    }
  }

  public citySearch(search: string): void {
    if (search.length >= 3) {
      this.searchQuery = search;
      this.searchLengthReached = true;
    } else {
      this.searchQuery = search;
      this.searchLengthReached = false;
    }
  }

  public getHsgError(fieldName: string): { key: string; message: string } | null {
    if (!this.errorsBag) {
      return null;
    }
    return typeof this.errorsBag[fieldName] === 'object' ? this.errorsBag[fieldName] : null;
  }

  public contractSubmit(): Promise<void> {
    this.errorsBag = null;
    this.data.phoneHomeAreaCode = '00';
    this.data.phoneMobileAreaCode = '00';
    this.data.billingPhoneAreaCode = '00';

    return ApiProvider.sessionUpdate(this.data, this.streetData.street, this.streetData.houseNumber)
      .then((response) => {
        this.validateContract(response);
      })
      .catch((error) => {
        if (typeof error.response !== 'undefined' && error.response.data.error.message === 'session outdated') {
          localStorage.removeItem(process.env.VUE_APP_SESSION_STORAGE_KEY);
          window.location.href = document.referrer || window.location.origin;
        }
      });
  }

  public validateContract(response: AxiosResponse): void {
    ApiProvider.validateContract()
      .then(() => {
        this.store.commit('SET_SESSION', {
          ...this.data,
          street: this.streetData.street,
          houseNumber: this.streetData.houseNumber
        });
        trackingProvider.validationContractSuccessful(this.sessionState, this.data, this.$props.product);
        this.$emit('contractSubmit', response.data);
      })
      .catch((error) => {
        trackingProvider.validationContractFailed();
        if (error.response.data && typeof error.response.data.error !== 'undefined') {
          this.errorsBag = error.response.data.error.messages;
        }
        this.$emit('scrollToTop');
      });
  }

  protected isNumeric(value: string): boolean {
    return /^-{0,1}\d+$/.test(value);
  }

  protected citiesNormalizing(filteredCities: CityData[], type: string): CityData[] {
    return filteredCities.map((city) => {
      const cityNormalized = { ...city };
      if (cityNormalized.zip.length < 5) {
        cityNormalized.text = '0' + city.text;
        cityNormalized.zip = '0' + city.zip;
      }
      cityNormalized.zipText = type === 'zip' ? cityNormalized.zip : cityNormalized.text;
      return cityNormalized;
    });
  }

  protected maskPhoneFocusOut(phone: string): void {
    this.focusPhone = false;
    switch (phone) {
      case 'home':
        this.data.phoneHome = ('' + this.data.phoneHome).replace(/[^0-9+]/g, '');
        break;
      case 'mobile':
        this.data.phoneMobile = ('' + this.data.phoneMobile).replace(/[^0-9+]/g, '');
        break;
      case 'billing':
        this.data.billingPhone = ('' + this.data.billingPhone).replace(/[^0-9+]/g, '');
        break;
    }
  }

  protected checkValidForm(): void | boolean {
    if (this.isErrorHsgMinimumAgeRequired) {
      return false;
    }
    this.contractSubmit();
  }
}
